export default __webpack_public_path__ + "static/N0114-75be398d17b1ea1b6b0e160ceb9255ab.png";